import { LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import { CybersourceState } from '../types'
import * as actions from './actions'
import { initialState } from './initialState'

const initCybersourceCheckout = (state, { keyId }): CybersourceState => ({
  ...state,
  keyId,
  status: LoadingStates.LoadedSuccess,
})

const updateCybersourceCheckout = (state, { authData }): CybersourceState => ({
  ...state,
  authData,
  status: LoadingStates.LoadedSuccess,
})

const completeCybersourceCheckout = (state): CybersourceState => ({
  ...state,
  authData: null,
  status: LoadingStates.NotLoaded,
})

const apiInitCybersourceStart = (state): CybersourceState => ({
  ...state,
  status: LoadingStates.Loading,
})

const apiInitCybersourceSuccess = (state, { keyId }): CybersourceState => ({
  ...state,
  keyId,
  status: LoadingStates.LoadedSuccess,
})

const apiInitCybersourceFail = (state): CybersourceState => ({
  ...state,
  status: LoadingStates.LoadedFail,
})

export default createReducer((on) => {
  on(actions.initCybersourceCheckout, initCybersourceCheckout)
  on(actions.updateCybersourceCheckout, updateCybersourceCheckout)
  on(actions.completeCybersourceCheckout, completeCybersourceCheckout)
  on(actions.apiInitCybersourceStart, apiInitCybersourceStart)
  on(actions.apiInitCybersourceSuccess, apiInitCybersourceSuccess)
  on(actions.apiInitCybersourceFail, apiInitCybersourceFail)
}, initialState)
